import { FRONT_URL } from '../constants/env.constant';

export const isDevelop = () => {
  return FRONT_URL?.includes('test');
};
